module.exports = __webpack_public_path__ + "static/media/search-bg-03.c21e6953.jpg";